/** Attached to idle-timeout terminal RequestError.statusCode */
export const SMS_OTP_IDLE_TIMEOUT_STATUS_CODE = 'SMS_OTP_IDLE_TIMEOUT';

/** Attached to verify HTTP 429 / too-many-failed SMS OTP attempts RequestError.statusCode */
export const SMS_OTP_VERIFY_RATE_LIMIT_STATUS_CODE = 'SMS_OTP_VERIFY_RATE_LIMIT';

export type SmsOtpLoginSession = {
  /** True once the initial screen-load send attempt completes (success or failure). */
  initialSendEverAttempted: boolean;
  /** Completed successful /send responses in this MFA challenge. */
  successfulSendCount: number;
  /** After idle terminal: hide SMS factor for rest of MFA challenge. */
  removedFromChooser: boolean;
  /** Last successful send token for verify across factor switches within one challenge. */
  lastSessionId: string;
};

export function createSmsOtpLoginSession(): SmsOtpLoginSession {
  return {
    initialSendEverAttempted: false,
    successfulSendCount: 0,
    removedFromChooser: false,
    lastSessionId: '',
  };
}

/** Patches emitted from OtpUserLoginHandler merged by parent controllers. */
export type SmsOtpLoginSessionPatch = {
  initialSendEverAttempted?: boolean;
  successfulSendIncrement?: number;
  lastSessionId?: string;
  removedFromChooser?: boolean;
};
